import { CalendarPlus, UserPlus, MessageSquare, CalendarDays } from 'lucide-react';

export const QuickActions = ({ onNewAppointment, onAddCustomer, onQuotes, onSchedule, quoteCount }) => {
  const actions = [
    { id: 'new-appointment', label: 'New Appointment', icon: CalendarPlus, onClick: onNewAppointment },
    { id: 'add-customer', label: 'Add Customer', icon: UserPlus, onClick: onAddCustomer },
    { id: 'view-quotes', label: 'Quote Requests', icon: MessageSquare, onClick: onQuotes, badge: quoteCount },
    { id: 'open-schedule', label: 'Schedule', icon: CalendarDays, onClick: onSchedule },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-6">
      {actions.map(({ id, label, icon: Icon, onClick, badge }) => (
        <button
          key={id}
          type="button"
          onClick={onClick}
          data-testid={`quick-action-${id}`}
          className="group relative flex items-center gap-3 bg-green-600 hover:bg-green-700 rounded-2xl p-3 sm:p-5 shadow-md shadow-green-700/20 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 text-left"
        >
          <span className="h-9 w-9 sm:h-11 sm:w-11 rounded-xl bg-white/20 flex items-center justify-center shrink-0">
            <Icon className="h-5 w-5 sm:h-6 sm:w-6 text-white" strokeWidth={2.4} />
          </span>
          <span className="font-bold text-white text-sm sm:text-base min-w-0" style={{ fontFamily: "'Outfit', sans-serif" }}>{label}</span>
          {badge > 0 && (
            <span className="absolute top-2 right-2 min-w-[20px] h-5 px-1.5 rounded-full bg-lime-400 text-stone-900 text-xs font-bold flex items-center justify-center" data-testid="quick-action-quotes-badge">
              {badge}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};
